import type { FormState } from 'app/components/timeSavers/assignMultipleTasksModal/Container';

export const validateForm = (
  formState: FormState,
  preSelectedPosts: number[],
): Record<string, string> => {
  let errors: Record<string, string> = {};

  if (!formState.selectedPosts.length && !preSelectedPosts.length) {
    errors.selectedPosts = 'At least one post must be selected';
  }

  if (!formState.selectedUsers.length) {
    errors.selectedUsers = 'At least one user must be selected';
  }

  return errors;
};
